import { Text } from '@carnica/ui-kit';
import React from 'react';
import { cnBem } from "../../../../shared/lib";
import styles from "./styles.pcss";
var cnCaptcha = cnBem('captcha', styles);
export var Captcha = function Captcha(_ref) {
  var message = _ref.message;
  var content = message.message.content,
    captcha = message.captcha;
  return captcha ? /*#__PURE__*/React.createElement("img", {
    alt: "\u041A\u0430\u043F\u0447\u0430",
    className: cnCaptcha(),
    src: captcha,
    "data-t-id": "ui-Captcha"
  }) : /*#__PURE__*/React.createElement(Text, {
    color: "primary-invert",
    variant: "body-small"
  }, content);
};